import React, { useCallback, useEffect, useState } from "react";
import PreviewFonts from "./PreviewFonts";
import SectionBoxWrapper from "../../SectionBox/SectionBoxWrapper";
import PreviewBox from "../../SectionBox/PreviewBox";
import FontSelection from "..";

export interface SectionBoxFontsProps {
  themeConfig: any;
  onSubmit: any;
}

/* Update heading/body font selection and preview live font changes. */
const SectionBoxFonts: React.FunctionComponent<SectionBoxFontsProps> = ({
  themeConfig,
  onSubmit,
}) => {
  const [headingFont, setHeadingFont] = useState(""); // maps to API field: globalFont
  const [bodyFont, setBodyFont] = useState(""); // maps to API field: highlightFont
  const [initialized, setInitialized] = useState(false);

  const setInitialData = useCallback(() => {
    if (headingFont) return;
    const { globalFont, highlightFont } = themeConfig;

    setHeadingFont(globalFont || "");
    setBodyFont(highlightFont || "");
    setInitialized(true);
  }, [headingFont, themeConfig]);
  console.log("gdfgdfgdfhdfhfghfghfghfgh, ", themeConfig);
  useEffect(() => {
    setInitialData();
  }, [setInitialData]);

  const handleSave = () => {
    onSubmit({
      globalFont: headingFont,
      highlightFont: bodyFont,
    });
  };

  const handleCancel = () => {
    setHeadingFont(themeConfig.globalFont || "");
    setBodyFont(themeConfig.highlightFont || "");
  };
  console.log("Sdfsdsdgdfgdh", headingFont);
  return (
    <SectionBoxWrapper
      sectionTitle={"Fonts"}
      onSubmit={handleSave}
      onCancel={handleCancel}
      colorChangeSection={
        <>
          <FontSelection
            title={"Highlight Font"}
            value={bodyFont}
            setValue={setBodyFont}
            previewText={"How would you like to place your order?"}
          />
          <FontSelection
            title={"Global Font"}
            value={headingFont}
            setValue={setHeadingFont}
            previewText={"Select Order Type"}
          />
        </>
      }
      previewSection={
        <PreviewBox bgColor={themeConfig.menuBackgroundColor}>
          <PreviewFonts
            headingFont={bodyFont}
            bodyFont={headingFont}
            textColor={themeConfig.titleTextColor}
          />
        </PreviewBox>
      }
    />
  );
};

export default SectionBoxFonts;
